document.addEventListener('DOMContentLoaded', () => {
  const showcases = document.querySelectorAll('[data-video-showcase]');

  showcases.forEach((showcase) => {
    initVideoShowcase(showcase);
  });
});

function initVideoShowcase(showcase) {
  const wrapper = showcase.querySelector('.product-video-showcase__video-wrapper');
  const video = showcase.querySelector('.product-video-showcase__video');
  const playButton = showcase.querySelector('[data-video-play]');

  if (!wrapper || !video || !playButton) {
    return;
  }

  playButton.addEventListener('click', async () => {
    wrapper.classList.add('is-playing');

    try {
      await video.play();
    } catch (error) {
      wrapper.classList.remove('is-playing');
      console.warn('Video could not autoplay after interaction:', error);
    }
  });

  video.addEventListener('play', () => {
    wrapper.classList.add('is-playing');
  });

  video.addEventListener('pause', () => {
    if (!video.ended) {
      wrapper.classList.add('is-playing');
    }
  });

  video.addEventListener('ended', () => {
    wrapper.classList.remove('is-playing');
    video.currentTime = 0;
  });
}